<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="info"
        v-bind="attrs"
        v-on="on"
      >
        {{ $t('common.view') }}
      </v-btn>
    </template>

    <v-card>
      <v-card-text>
        <GmapMap ref="map"
        :center="mapPos"
          :zoom="12"
          map-type-id="terrain"
          style="width: 100%; height: 400px"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false
          }"
        >
          <GmapMarker
            :position="currentPos"
            :clickable="false"
            :draggable="false"
          />
        </GmapMap>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          {{ $t('common.buttons.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';

export default {
  props: ['location'],
  data() {
    return {
      dialog: false,
      mapPos: { lat: -28, lng: 26 },
      currentPos: { lat: -28, lng: 26 },
    };
  },
  computed: {
    google() {
      return gmapApi();
    },
  },
  watch: {
    // location: {
    //   immediate: true,
    //   deep: true,
    //   async handler() {
    //     await this.setLocation();
    //   },
    // },
    dialog: {
      immediate: true,
      deep: true,
      handler() {
        if (this.dialog) {
          setTimeout(async () => {
            await this.setLocation();
          }, 800);
        }
      },
    },
  },
  methods: {
    parseMapItemPoint(point) {
      if (!point) {
        return undefined;
      }
      const coord = point?.geography?.wellKnownText?.replace('POINT ', '')
        .replace('(', '')
        .replace(')', '');
      const coordArr = coord.split(/[ ,]+/);
      const lat = parseFloat(coordArr[1]);
      const lng = parseFloat(coordArr[0]);
      this.$log.info(coordArr);
      // eslint-disable-next-line no-undef
      const latLng = new google.maps.LatLng(lat, lng);
      return latLng;
    },
    async setLocation() {
      await this.$refs.map.$mapPromise;
      const mapPos = this.parseMapItemPoint(this.location);
      this.$log.debug('Map available panning to:');
      this.$log.debug(mapPos);
      this.$refs.map.panTo(mapPos);
      this.currentPos = mapPos;
    },
  },
};
</script>
